// extracted by mini-css-extract-plugin
module.exports = {"container":"GOLBoard_container__3J5Sq"};